export const snapshotExcludeBootQueryFilter = [['pool', '!=', 'freenas-boot'], ['pool', '!=', 'boot-pool']];
